export default __webpack_public_path__ + "static/eqzEDIaI-345f7cab1005ae28f4a61a991abe90f0.svg";